// components/SuggestedQuestions.tsx
import React from "react";

// Sample question suggestions for quick research
const sampleQuestions = [
  "⁠Who are the competitors of Thermogenics?",
  "What’s ebitda margin for thermogenics for the last 4 years?",
  "Company values",
];

type Props = {
  onQuestionClick?: (question: string) => void; 
};

const SuggestedQuestions: React.FC<Props> = ({ onQuestionClick }) => {
  return (
    <section className="text-center  ">

        
      <p className="text-sm text-gray-500 mb-2 mt-10 ">Powered by 8byte.ai</p>
      <h1 className="text-5xl   mb-6"
       style={{ fontFamily: '"Inter", "SF Pro Display", "Helvetica Neue", sans-serif',  fontWeight: 300,}} 
      >Ask Research Agent</h1>

      {/* Render sample question buttons */}
      <div className="flex flex-wrap justify-center gap-4 ">
        {sampleQuestions.map((question, index) => (
          <button
            key={index}
             onClick={() => onQuestionClick?.(question)}
            className="bg-gray-50  border max-w-55 border-gray-300 rounded-2xl px-4 py-4 text-sm text-gray-700 shadow hover:shadow-md transition"
          >
            {question}
          </button>
        ))}
      </div>
    </section>
  );
};

export default SuggestedQuestions;
